// Content load handler
// - Fügt Klassen bei DOMContentLoaded / load hinzu
// - Lazy-load für Elemente mit `data-src`
// - Entfernt optionalen Preloader (#preloader)
// Lazy Loading Handler
// - Lazy-load für Elemente mit `data-src`
// - Verwendet IntersectionObserver für Performance
// - Video-Setup für proxy loading via HTML
// Speichern der gehashten Video-Pfade
let $32a3a3f71f269bc5$var$videoSources = {
    desktop: {},
    mobile: {}
};
function $32a3a3f71f269bc5$var$isImage(el) {
    return el.tagName.toLowerCase() === 'img';
}
function $32a3a3f71f269bc5$var$loadResource(el) {
    return new Promise((resolve)=>{
        if ($32a3a3f71f269bc5$var$isImage(el)) {
            const img = el;
            const src = img.dataset.src;
            if (!src) return resolve();
            img.onload = ()=>img.classList.add('loaded');
            img.onerror = ()=>img.classList.add('error');
            img.src = src;
            delete img.dataset.src;
            return resolve();
        }
        const src = el.getAttribute('data-src');
        if (src) {
            if (el instanceof HTMLIFrameElement) el.src = src;
            else el.setAttribute('style', (el.getAttribute('style') || '') + `background-image:url('${src}')`);
            el.removeAttribute('data-src');
        }
        resolve();
    });
}
function $32a3a3f71f269bc5$export$c3bf910d26c7ca3b() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const src = source.getAttribute('src');
        const type = source.getAttribute('type') || '';
        if (!src) return;
        const isMobile = source.getAttribute('data-mobile') === 'true';
        if (isMobile) $32a3a3f71f269bc5$var$videoSources.mobile[type] = src;
        else $32a3a3f71f269bc5$var$videoSources.desktop[type] = src;
        // src entfernen, damit Video nicht sofort geladen wird
        source.removeAttribute('src');
    });
}
function $32a3a3f71f269bc5$export$730a095e8e4092e5() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const variant = isMobile ? $32a3a3f71f269bc5$var$videoSources.mobile : $32a3a3f71f269bc5$var$videoSources.desktop;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const type = source.getAttribute('type') || '';
        if (variant[type]) source.setAttribute('src', variant[type]);
    });
    v.load();
    v.autoplay = true;
    v.play().catch(()=>{});
}
function $32a3a3f71f269bc5$export$3b98fa096e9fc203(root = document) {
    return new Promise((resolve)=>{
        const nodes = Array.from(root.querySelectorAll('[data-src]'));
        if (!nodes.length) {
            resolve();
            return;
        }
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs)=>{
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    const el = entry.target;
                    $32a3a3f71f269bc5$var$loadResource(el).catch(()=>{});
                    obs.unobserve(entry.target);
                });
            }, {
                root: null,
                threshold: 0
            });
            nodes.forEach((n)=>io.observe(n));
            resolve(); // IntersectionObserver Setup fertig
        } else // Fallback: load all immediately
        Promise.all(nodes.map((n)=>$32a3a3f71f269bc5$var$loadResource(n))).then(()=>resolve()).catch(()=>resolve());
    });
}


// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset
function $e745b9ef5c505b0a$var$smoothScrollToTarget(href) {
    // Anchor href auslesen
    if (!href.startsWith('#')) return;
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    // Topbar-Höhe ermitteln
    const topbar = document.querySelector('.fuelpipe-topbar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    // Scroll-Position berechnen
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight;
    // Smooth Scroll ausführen
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}
function $e745b9ef5c505b0a$export$b61d4be8ddba9539() {
    const toggle = document.querySelector('.menu-toggle');
    const backdrop = document.querySelector('.menu-backdrop');
    const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');
    if (!toggle || !backdrop) return;
    const toggleMenu = ()=>{
        const isOpen = document.body.classList.toggle('nav-open');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(isOpen));
    };
    // Dropdown click handling
    const dropdownItems = document.querySelectorAll('li.has-dropdown');
    dropdownItems.forEach((item)=>{
        const trigger = item.querySelector(':scope > a');
        if (!trigger) return;
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        const toggleDropdown = (open)=>{
            const isOpen = open !== undefined ? open : !item.classList.contains('dropdown-open');
            item.classList.toggle('dropdown-open', isOpen);
            trigger.setAttribute('aria-expanded', String(isOpen));
        };
        trigger.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
            // Close other open dropdowns
            dropdownItems.forEach((other)=>{
                if (other !== item) {
                    other.classList.remove('dropdown-open');
                    const otherTrigger = other.querySelector(':scope > a');
                    if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
                }
            });
        });
        // Escape-Taste schließt das Dropdown
        trigger.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') toggleDropdown(false);
        });
    });
    // Close dropdown on outside click
    document.addEventListener('click', ()=>{
        dropdownItems.forEach((item)=>{
            item.classList.remove('dropdown-open');
            const trigger = item.querySelector(':scope > a');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
    });
    toggle.addEventListener('click', (e)=>{
        e.stopPropagation();
        toggleMenu();
    });
    backdrop.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const href = link.getAttribute('href');
            // Wenn es ein Anker ist, smooth scroll triggern
            if (href?.startsWith('#')) {
                e.preventDefault();
                $e745b9ef5c505b0a$var$smoothScrollToTarget(href);
            }
            // Menü schließen wenn offen
            if (document.body.classList.contains('nav-open')) toggleMenu();
        });
    });
}


// Scroll Animations Handler
// - Element-basierte Animationen
// - Jedes Element mit [data-animate] triggert unabhängig
// - Respektive auch bei langen Sections früh auslösen
function $b611819413d23cbb$export$4ae6feb6159b4594() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    if (!animatedElements.length) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const element = entry.target;
            const customDelay = parseFloat(element.getAttribute('data-delay') || '0') * 1000; // in ms
            element.style.animationDelay = `${customDelay}ms`;
            element.classList.add('animate-in');
            // Element nach Animation nicht mehr beobachten
            observer.unobserve(element);
        });
    }, {
        threshold: 0.1
    });
    // Alle animierten Elemente beobachten
    animatedElements.forEach((element)=>{
        observer.observe(element);
    });
}


// Scroll Morph Handler
// - Überblendung zwischen .normal und .morph Bildern gekoppelt an Scroll-Fortschritt
// - Beginn: Element in Bildschirmmitte
// - Ende: Element am oberen Rand (minus Topbar-Höhe)
// - Bidirektional: Vorwärts und Rückwärts-Scrollen funktioniert
const $042d2a1a583b6f8f$var$TOPBAR_HEIGHT = 80; // px - CSS @topbar-height
function $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c() {
    const morphContainers = document.querySelectorAll('.foto-morph');
    if (!morphContainers.length) return;
    const configs = Array.from(morphContainers).map((container)=>{
        const morphImg = container.querySelector('img.morph');
        return {
            container: container,
            morphImg: morphImg
        };
    }).filter((config)=>config.morphImg);
    if (!configs.length) return;
    // Update Morph-Opacity kontinuierlich beim Scroll
    const updateMorphOpacity = ()=>{
        configs.forEach(({ container: container, morphImg: morphImg })=>{
            // Bounding Rect vom Container
            const rect = container.getBoundingClientRect();
            const containerCenter = rect.top; // + rect.height / 2;
            const isMobile = window.matchMedia('(max-width:768px)').matches;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            const startPoint = isMobile ? viewportHeight * 0.45 - 100 : viewportHeight * 0.45; // Bildschirmmitte
            const endPoint = isMobile ? $042d2a1a583b6f8f$var$TOPBAR_HEIGHT : $042d2a1a583b6f8f$var$TOPBAR_HEIGHT + 100; // Oberer Rand minus Topbar
            // Scroll-Fortschritt berechnen (0 = Start, 1 = Ende)
            // Wenn Container-Mitte in Bildschirmmitte ist: progress = 0
            // Wenn Container-Mitte am oberen Rand ist: progress = 1
            const distanceFromMidpoint = startPoint - containerCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let progress = distanceFromMidpoint / activationRange;
            progress = Math.max(0, Math.min(1, progress));
            // Opacity setzen (nur für .morph Bild)
            morphImg.style.opacity = String(progress);
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateMorphOpacity();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Scroll Heading Handler
// - Zerlegt .heading h2 in einzelne Wörter
// - Animiert Wörter einzeln beim Scrollen (blur + skew + opacity)
// - Start: wenn h2 sichtbar wird (unten im Viewport)
// - Ende: wenn h2 oberhalb der Bildschirmmitte
function $0e5e9a9af84e2131$export$c80c5dc5e82459e5() {
    const headings = document.querySelectorAll('.heading h2[data-animate]');
    if (!headings.length) return;
    const configs = Array.from(headings).map((h2)=>{
        const heading = h2.closest('.heading');
        if (!heading) return null;
        // Original-Kindknoten merken, dann h2 leeren.
        // Wir laufen über die Knoten (statt textContent), damit Inline-Markup
        // wie <sup class="reg">®</sup> erhalten bleibt.
        const originalNodes = Array.from(h2.childNodes);
        h2.innerHTML = '';
        const wordSpans = [];
        let current = null;
        const startWord = ()=>{
            const span = document.createElement('span');
            span.style.display = 'inline-block';
            span.style.marginRight = '0.3em';
            span.style.willChange = 'filter, transform, opacity';
            h2.appendChild(span);
            wordSpans.push({
                span: span
            });
            current = span;
            return span;
        };
        originalNodes.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) // Text an Whitespace zerlegen; Leerraum trennt Wörter
            (node.textContent || '').split(/(\s+)/).forEach((part)=>{
                if (part === '') return;
                if (/^\s+$/.test(part)) current = null; // Worttrenner
                else (current ?? startWord()).appendChild(document.createTextNode(part));
            });
            else // Inline-Element (z. B. <sup>) an aktuelles Wort hängen
            (current ?? startWord()).appendChild(node.cloneNode(true));
        });
        return {
            heading: heading,
            h2: h2,
            wordSpans: wordSpans
        };
    }).filter((config)=>config !== null);
    if (!configs.length) return;
    // Update Heading-Animation kontinuierlich beim Scroll
    const updateHeadingAnimation = ()=>{
        configs.forEach(({ heading: heading, wordSpans: wordSpans })=>{
            // Bounding Rect vom Heading
            const rect = heading.getBoundingClientRect();
            const headingCenter = rect.top + rect.height / 2;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            // Start: Element kommt unten in Sicht (viewportHeight)
            // Ende: Element ist oberhalb der Bildschirmmitte (viewportHeight / 2)
            const startPoint = viewportHeight; // Unten - Animation beginnt
            const endPoint = viewportHeight / 2; // Mitte - Animation abgeschlossen
            // Position des Heading-Mittelpunkts bei MAXIMALEM Scroll.
            // (Konstant pro Heading, da rect.top und remainingScroll sich beim
            //  Scrollen gegenseitig aufheben.) Headings direkt vor dem Footer
            //  können den endPoint sonst nie erreichen und blieben unscharf.
            const maxScrollY = document.documentElement.scrollHeight - viewportHeight;
            const remainingScroll = Math.max(0, maxScrollY - window.scrollY);
            const reachableCenter = headingCenter - remainingScroll;
            // Erreichbaren Zielpunkt nehmen, falls der normale endPoint zu hoch
            // liegt. Für erreichbare Headings bleibt es exakt beim endPoint.
            const effectiveEndPoint = Math.max(endPoint, reachableCenter);
            const activationRange = startPoint - effectiveEndPoint;
            // Fortschritt je näher Element nach oben kommt, clamped zwischen 0 und 1
            const distanceFromMidpoint = startPoint - headingCenter;
            let overallProgress = activationRange > 0 ? distanceFromMidpoint / activationRange : 1;
            overallProgress = Math.max(0, Math.min(1, overallProgress));
            // Berechne gesamte Stagger-Verzögerung (vom ersten bis letzten Wort)
            const totalWordDelay = (wordSpans.length - 1) * 0.08;
            // Skaliere overallProgress so, dass die Animation über ALLE Wörter läuft
            const adjustedProgress = overallProgress * (1 + totalWordDelay);
            // Für jedes Wort: individueller Fortschritt
            wordSpans.forEach((word, index)=>{
                // Jedes Wort animiert mit Stagger-Effekt
                const wordDelay = index * 0.08; // 8% Stagger pro Wort
                // Fortschritt für dieses Wort (0 bis 1, mit Stagger)
                const wordProgress = Math.max(0, Math.min(1, adjustedProgress - wordDelay));
                // Interpoliere Blur-Effekt
                const blur = 8 * (1 - wordProgress); // Von 8px zu 0px
                const skew = -20 * (1 - wordProgress); // Von -20deg zu 0deg
                const opacity = wordProgress; // Von 0 zu 1
                // CSS anwenden
                word.span.style.filter = `blur(${blur}px)`;
                word.span.style.transform = `skew(${skew}deg)`;
                word.span.style.opacity = String(opacity);
            });
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateHeadingAnimation();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Kontaktformular – Anbindung an den Mailrelay
// - konfigurationsgetrieben: die Form-ID kommt aus `data-form-id` (muss in forms.yaml stehen)
// - Honeypot-Feld `_hp` + Zeitfalle `_elapsed` als simpler Bot-Schutz
// - Status-Ausgabe erfolgt in `.form-status` innerhalb des Formulars
//
// Native Browser-Validierung bleibt aktiv: das submit-Event feuert erst,
// wenn alle `required`-Felder gültig sind.
// Mailrelay läuft auf Coolify unter eigener Subdomain. Aufruf cross-origin –
// der Service setzt die CORS-Header selbst, sofern der Origin in forms.yaml steht.
const $ad4f0b2a557d6e0f$var$ENDPOINT = 'https://contact-mailrelay.s1.fuelpipe.de/submit';
const $ad4f0b2a557d6e0f$var$MSG_SUCCESS = "Vielen Dank! Deine Nachricht ist angekommen \u2013 ich melde mich zeitnah bei dir.";
const $ad4f0b2a557d6e0f$var$MSG_ERROR = "Das hat leider nicht geklappt. Bitte versuche es sp\xe4ter erneut oder schreib mir direkt an mail@equida.horse.";
const $ad4f0b2a557d6e0f$var$MSG_SENDING = "Nachricht wird gesendet \u2026";
function $ad4f0b2a557d6e0f$var$setStatus(form, kind, text) {
    const status = form.querySelector('.form-status');
    if (!status) return;
    status.classList.remove('is-sending', 'is-success', 'is-error');
    status.classList.add(`is-${kind}`, 'is-visible');
    status.textContent = text;
}
function $ad4f0b2a557d6e0f$export$d5bd5b80f649d6c(form) {
    const loadedAt = Date.now(); // Start der Zeitfalle
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const raw = Object.fromEntries(new FormData(form));
        // Leere optionale Felder gar nicht erst mitschicken: der Relay wertet
        // einen leeren String als fehlendes Feld und antwortet mit 400
        // ({"error":"missing_field"}). Weggelassen ist dagegen in Ordnung.
        const data = {};
        for (const [key, value] of Object.entries(raw))if (String(value).trim() !== '') data[key] = value;
        data._hp = raw._hp ?? ''; // Honeypot immer mitschicken, auch leer
        data.formId = form.dataset.formId ?? '';
        data._elapsed = String(Date.now() - loadedAt); // Delta -> kein Uhren-Problem
        const btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        $ad4f0b2a557d6e0f$var$setStatus(form, 'sending', $ad4f0b2a557d6e0f$var$MSG_SENDING);
        try {
            const res = await fetch($ad4f0b2a557d6e0f$var$ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            form.reset();
            $ad4f0b2a557d6e0f$var$setStatus(form, 'success', $ad4f0b2a557d6e0f$var$MSG_SUCCESS);
        } catch (err) {
            console.error('Versand fehlgeschlagen:', err);
            $ad4f0b2a557d6e0f$var$setStatus(form, 'error', $ad4f0b2a557d6e0f$var$MSG_ERROR);
        } finally{
            if (btn) btn.disabled = false;
        }
    });
}
function $ad4f0b2a557d6e0f$export$d708bc7863f73f75(root = document) {
    root.querySelectorAll('form[data-form-id]').forEach($ad4f0b2a557d6e0f$export$d5bd5b80f649d6c);
}


function $e366f2c43bf887ab$var$removePreloader() {
    const pre = document.getElementById('preloader');
    if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
}
function $e366f2c43bf887ab$var$initHeroAnimation() {
    const teaser = document.getElementById('teaser');
    if (teaser) teaser.classList.add('animate-in');
}
function $e366f2c43bf887ab$var$onDOMContentLoaded() {
    document.documentElement.classList.add('dom-ready');
    document.body.classList.add('dom-ready');
    // LazyLoad zuerst
    (0, $32a3a3f71f269bc5$export$3b98fa096e9fc203)(document);
    // Video-Pfade aus HTML auslesen und speichern
    (0, $32a3a3f71f269bc5$export$c3bf910d26c7ca3b)();
    (0, $e745b9ef5c505b0a$export$b61d4be8ddba9539)();
    // Kontaktformular(e) anbinden
    (0, $ad4f0b2a557d6e0f$export$d708bc7863f73f75)();
}
function $e366f2c43bf887ab$var$onWindowLoad() {
    document.documentElement.classList.add('loaded');
    document.body.classList.add('loaded');
    $e366f2c43bf887ab$var$removePreloader();
    // Hero-Animation sofort triggern
    $e366f2c43bf887ab$var$initHeroAnimation();
    // Animationen erst NACH Preloader-Entfernung
    (0, $b611819413d23cbb$export$4ae6feb6159b4594)();
    // Scroll-Morph initialisieren
    (0, $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c)();
    // Scroll-Heading initialisieren
    (0, $0e5e9a9af84e2131$export$c80c5dc5e82459e5)();
    // Video Setup mit richtiger Variante
    (0, $32a3a3f71f269bc5$export$730a095e8e4092e5)();
}
function $e366f2c43bf887ab$export$c1e92a604cbf4acd() {
    if (document.readyState === 'complete') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        $e366f2c43bf887ab$var$onWindowLoad();
        return;
    }
    if (document.readyState === 'interactive') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
            once: true
        });
        return;
    }
    window.addEventListener('DOMContentLoaded', $e366f2c43bf887ab$var$onDOMContentLoaded, {
        once: true
    });
    window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
        once: true
    });
}
// Auto-init when module is imported
$e366f2c43bf887ab$export$c1e92a604cbf4acd();


//# sourceMappingURL=equida.730c89e5.js.map
